import { Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import "./HomePage.css";
import {
  contacts,
  homepageInformation,
  experienceInformation,
} from "../../information/information";
import EmailIcon from "@mui/icons-material/Email";
import ProjectsShowCase from "../../components/ProjectsShowCase/ProjectsShowCase";
import { Internship, Project } from "../../interfaces/InformationInterface";
import ProjectShowCaseDetail from "../../components/ProjectShowCaseDetail/ProjectShowCaseDetail";
function HomePage() {
  const { projects } = experienceInformation;
  const [informDetail,setInform] = useState<Internship|Project|null>(null);
  const contactscmp = React.useMemo(() => {
    const { website, gmail, phoneNumber } = contacts;
    let cmp = website.map(({ url, icon, name }) => (
      <Grid item key={name}>
        <IconButton onClick={() => window.open(url)}>{icon}</IconButton>
      </Grid>
    ));
    // add gmail icon
    if (gmail) {
      cmp.push(
        <Grid item key={gmail}>
          <IconButton href={`mailto:${gmail}`}>
            <EmailIcon />
          </IconButton>
        </Grid>
      );
    }
    return cmp;
  }, []);
  
  return (
    <div id="HomePage">
      <ProjectShowCaseDetail hide={informDetail==null} onClose={()=>setInform(null)} information={informDetail}/>
      <Grid container spacing={4}>
        <Grid item>
          <Grid container direction={"row"} spacing={1}>
            <Grid item xs={7} className="article">
              <Grid
                container
                direction={"column"}
                className="article_container"
              >
                <Grid item>
                  <Typography variant="h3" className="title">
                    {homepageInformation.title}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body1" className="about_paragraph">
                    {homepageInformation.paragraph}
                  </Typography>
                </Grid>
                <Grid item>
                  <Grid container direction={"row"}>
                    {contactscmp}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={5}>
              <img
              referrerPolicy="no-referrer"
                src={homepageInformation.urlImg}
                alt="homepage img"
                className="article_picture"
                loading="lazy"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <ProjectsShowCase projects={projects} onClick={(project)=>setInform(project)}/>
        </Grid>
      </Grid>
    </div>
  );
}

export default HomePage;
